export const displayUrlOf = ({ url, thumbnailUrl }: { url: string; thumbnailUrl: string | null }) => thumbnailUrl ?? url
